export function dateFormat(dateString) {
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
export function dateFormatDayMonthYear(dateString) {
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${day}-${month}-${year}`;
}

export function formatDateTime(dateString) {
  const date = new Date(dateString);
  if (isNaN(date)) return "";

  const options = {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-US", options);
}

export function formatDate(dateInput) {
  const date = new Date(dateInput);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

export function formatDateToDDMMYYYY(dateValue) {
  if (!dateValue) return "N/A";
  try {
    const dateString = String(dateValue).split("T")[0];
    const parts = dateString.split("-");
    if (parts.length === 3 && parts[0].length === 4) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
  } catch (error) {
    return dateValue;
  }
}

export function validateInputSecurity(value) {
  if (!value) return "";

  const sqlPatterns = [/(\b(SELECT|INSERT|UPDATE|DELETE|DROP|CREATE|ALTER|EXEC)\b)/gi, /(--|\#|\/\*|\*\/)/g, /(\bOR\b\s+\d+\s*=\s*\d+)/gi, /(\bAND\b\s+\d+\s*=\s*\d+)/gi, /(;|\|)/g];
  if (sqlPatterns.some((pattern) => pattern.test(value))) {
    return "Invalid characters detected. Please avoid SQL special characters.";
  }

  const xssPatterns = [/[<>]/g, /<script/gi, /<iframe/gi, /javascript:/gi, /on\w+\s*=/gi];
  if (xssPatterns.some((pattern) => pattern.test(value))) {
    return "Invalid input detected. HTML/JavaScript is not allowed.";
  }

  return "";
}
